<template>

	<div class="body">
		<div class="close-btn" v-on:click="close">
			<i title="close" class="material-icons md-18">close</i>
		</div>
		<div class="title">EXPORT COLLECTION</div>
		<div v-if="!exportAllowed" class="lock-block lock-block-sharp mb-0">
			<div class="row mx-0 hover-dk" v-on:click="unlock">
				<div class="col-2 text-center my-auto">
					<i class="material-icons text-light mr-3 md-36">lock</i>
				</div>
				<div class="py-3 col-10 pl-0 pr-3 py-3">
					<h5 class="mb-0 text-white">Purchase day pass to unlock</h5>
					<h5 class="mb-0 font-weight-light text-light">Download data on your collection</h5>
				</div>
			</div>
		</div>
		<div v-if="!exportAllowed" class="p-3">
			<p class="text-sm">
				Purchase a plan to download data for this collection of parcels. Samples are provided to try before you buy.
			</p>
			<div class="mb-3">
				<h5 class="mb-2">
					PARCEL DATA
				</h5>
				<div class="action-row clearfix">
					<label class="mb-0 font-weight-normal button-label">Excel CSV</label>
					<div class="float-right font-weight-bold">
						<button v-on:click="download('csv')" class="btn btn-dark btn-sm"><i class="material-icons md-14">file_download</i> Sample</button>
					</div>
				</div>
			</div>
		</div>
		<div v-if="exportAllowed" class="p-3">
			<div class="mb-3">
				<h5 class="mb-2">
					PARCEL DATA
				</h5>
				<div class="action-row clearfix">
					<label class="mb-0 font-weight-normal button-label">Excel CSV</label>
					<div class="float-right font-weight-bold">
						<button v-on:click="download('csv')" class="btn btn-dark btn-sm"><i class="material-icons md-14">file_download</i> Download</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name:'collectionParcelExport',
	props: {
		collection:{
			type:Object,
		},
	},
	computed:{
		parcels: function(){
			return this.$store.state.collections.parcels;
		},
		planActive:function(){
			return this.$store.state.plan.active;
		},
		exportAllowed:function(){
			if (this.planActive) return true;
			// check if every parcel in collection is unlocked
			let allUnlocked = true;
			if (this.parcels.forEach((parcel)=>{
				if (!parcel.unlocked) allUnlocked = false;
			}))
			if (allUnlocked) return true;
			return false;
		},
		token: function(){
			return this.$store.state.agent.token;
		},
	},
	created: function(){
		this.getPlanActive();
	},
	data:function(){
		return {

		};
	},
	methods:{
		close:function(){
			this.$emit('close');
		},
		download:function(type){
			let url;
			if (this.exportAllowed){
				// /api/collections/:id/export
				url = '/api/collections/'+this.collection.id+'/export?format='+type;
				if (this.token) url += `&token=${this.token}`
			} else {
				switch(type) {
				case 'csv':
					url = 'https://s3.amazonaws.com/scoutred.com/web-static/download/examples/parcel-id-820969.csv';
					break;
				default:
					this.$store.dispatch('SET_ERROR', 'unsupported file type: '+type);
				}
			}

			window.open(url);
		},
		getPlanActive: function(){
			this.$store.dispatch('PLAN_ACTIVE_CHECK');			
		},
		unlock: function(){
			this.$router.push({
				name: 'unlock', 
				params:{
				},
				query:{
					next:this.$route.path
				}
			});
		},
	}
};

</script>


// WEBPACK FOOTER //
// src/components/collection/collection-parcel-export.vue